import { useEffect } from 'react';
import get from 'lodash/get';

import gift from '../functions/gift/gift';
import sendTip from '../functions/gift/send-tip';
import bag from '../functions/gift/bag';
import animate from '../functions/animation/animate';
import enterAnimate from '../functions/enter-effects/enter-animate';
import message from '../functions/messages/service';
import car from './car';
import medal from './medal';
import room from './room';
import socket from './socket';
import socketHandler from './socket-handler';
import auth from './auth';
import createStore from './create-store';
import menu from './menu';
import identity from './identity';
import { useRouter } from 'next/router';
import { debug } from 'lib';
import marquee from 'modules/widgets/functions/marquee/marquee';
import usePageClass from '../../../lib/hooks/use-page-class';

let log = debug.create('widgets');

const useWidget = (roomId, roomStore, opts = {}) => {
  let {
    roomType, //  -1:个播; 1:舞台房; 2:神豪厅; 3:多人pk房; 6: 多人派对房;
    isReady = true,
    initCar = true,
    initMedal = true,
    initGift = true,
    initBag = true,
    initAuth = true,
    initMarquee = true,
    initSocketHandler = {},
  } = opts;

  let router = useRouter();

  usePageClass(router.query.debug_ani ? '_debug_ani' : '');

  // log('useWidgets');

  room.init(roomId, {
    roomType,
    hostId: get(roomStore, 'room.roomInfo.host.uid', 0),
  });

  useEffect(() => {
    if (isReady) {
      const init = async () => {
        log('update');

        if (initCar) {
          car.init();
        }
        if (initMedal) {
          medal.init();
        }
        if (initGift) {
          gift.init(roomType, () => {
            if (initMarquee) {
              marquee.init();
            }
          });
        }
        if (initBag) {
          bag.init();
        }
        if (initAuth) {
          auth.init();
        }
        if (initSocketHandler) {
          socketHandler.init(initSocketHandler);
        }

        socket.init(roomId, roomStore, router.query);

        let _MMWidget = {
          useWidget,
          car,
          gift,
          socket,
          room,
          auth,
          createStore,
          message,
          menu,
          identity,
          animate,
          enterAnimate,
          sendTip,
        };

        Object.assign(window, {
          _MMWidget,
        });
      };

      init();

      return () => {
        socket.destroy();
      };
    }
  }, [roomId, isReady]);
};

export { useWidget, car, medal, gift, socket, room, auth, createStore, message, menu, identity };
